/** Shared field styles for thick authoring sections (DR1/DR2). */
export const FIELD_CLASS =
  'w-full rounded border border-[var(--color-border)] bg-[var(--color-surface-bg)] px-3 py-2 text-base text-[var(--color-surface-text)] focus:outline-none focus:ring-2 focus:ring-[var(--color-info)] disabled:opacity-60';
export const LABEL_CLASS = 'mb-1 block text-base font-medium text-[var(--color-surface-text)]';
export const HINT_CLASS = 'mt-1 text-base text-[var(--color-surface-text-secondary)]';
export const SECTION_CLASS =
  'rounded border border-[var(--color-border)] bg-[var(--color-secondary-bg)] p-4';

/**
 * Default Role prefill (DR1 — strong placeholder, not forced saved text).
 * Stored in expert_posture.
 */
export const DEFAULT_EXPERT_POSTURE =
  'Expert advisor for this process. Clear about assumptions, honest about data gaps, and escalates to a human when stakes or policy require confirmation.';

/** Placeholder for Objective (stored as purpose). */
export const DESCRIPTION_PLACEHOLDER =
  'What should this agent accomplish for the user? e.g. Find the best schedule that meets demand without overtime.';

/** Placeholder for Constraints (stored as scope_honesty). */
export const SCOPE_PLACEHOLDER =
  '- Stay within stated capacity and calendars\n- Prefer feasible plans over perfect ones\n- Never commit changes without human confirmation\n- Out of scope: sourcing, shipping, full plant maintenance';

/** Tooltip for name-derived agent code (frozen after Draft). */
export const AGENT_CODE_TOOLTIP =
  'Stable identifier derived from the agent name while Draft. Freezes when you set Private or Public. Used in APIs, logs, and support — you do not edit it.';
